import { captureApiError } from './captureApiError'

function handleStringInternalAPIResponse(response: Response, stringResponse: string, errorMessage?: string): unknown {
  if (response.ok) {
    return stringResponse === '' ? {} : JSON.parse(stringResponse)
  }

  const body = stringResponse === '' ? response.statusText : JSON.parse(stringResponse)
  const error = captureApiError({
    response,
    errorDetail: body,
    errorMessageLike: errorMessage,
    legacyStringResponse: stringResponse,
  })
  throw error
}

export async function handleInternalAPIResponse<Data = any>(response: Response, errorMessage?: string): Promise<Data> {
  return handleStringInternalAPIResponse(response, await response.text(), errorMessage) as Data
}
